import { LogLevel } from '../../constants';

/**
 * Validates whether a given value is a valid LogTypes.
 * @param value - The value to validate.
 * @returns True if valid, false otherwise.
 */
export function isValidLogType(value: unknown): value is LogLevel {
  return Object.values(LogLevel).includes(
    String(value).toLowerCase() as LogLevel,
  );
}

export class InvalidLogLevelError extends Error {
  /**
   * Creates a new instance of InvalidLogLevelError.
   * @param level - The invalid log level.
   */
  constructor(level: any) {
    super(`Invalid log level: ${level}`);
    this.name = 'InvalidLogLevelError';
  }
}

export function getRootSource(source: string): string {
  return source.split(':')[0];
}
